import { styled } from '@mui/material/styles';

const SharedMapWrapperHeight = theme => `
  height: 276px;
  min-height: 276px;
  
  ${theme.breakpoints.up('md')} {
    height: 434px;
    min-height: 434px;
  }
  ${theme.breakpoints.up('lg')} {
    height: 882px;
    min-height: 882px;
  }
`;

export const StyledMapWrapper = styled('div')(
  ({ theme }) => `
    ${SharedMapWrapperHeight(theme)};
    position: relative;
    z-index: 1;
  `,
);

export const StyledMapLoaderWrapper = styled('div')(
  ({ theme }) => `
    width: 100%;
    z-index: 1;
    ${SharedMapWrapperHeight(theme)};
    position: absolute;
      
    &::before {
      content: "";
      background-color: ${theme.DS_palette.background.lightgrey};
      opacity: 0.5;
      ${SharedMapWrapperHeight(theme)};
      width: 100%;
      position: absolute;
      top: 0;
    }
    
    > div {
      ${SharedMapWrapperHeight(theme)};
    }
    
    ${theme.breakpoints.up('lg')} {
      > div {
        > div {
          position: absolute;
          right: 27%;
        } 
      }
    }
 `,
);
